// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3V2Zi","top":"styles_top__3yHnK","left":"styles_left__1nwGD","description":"styles_description__1GhyX"};